import * as React from "react";

import { NavLink } from "react-router-dom";

import { makeFullUrl } from "../routing";

export interface IPageLinkProps {
    ariaLabel?: string;
    focuszoneId?: string;
    path: string;
}

class PageLink extends React.Component<IPageLinkProps> {
    public render() {
        return (
            <NavLink aria-label={this.props.ariaLabel} data-focuszone={this.props.focuszoneId} to={makeFullUrl(this.props.path)}>
                {this.props.children}
            </NavLink>
        );
    }
}

export default PageLink;
